import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import de from './de/homepage.json';
import en from './en/homepage.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { homepage: de },
      en: { homepage: en },
    },
    fallbackLng: 'de',
    defaultNS: 'homepage',
    ns: ['homepage'],
    detection: {
      order: ['path'],
      lookupFromPathIndex: 0,
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
